import { cn } from "@/lib/cn";

interface ProToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  "aria-label"?: string;
}

function ProToggle({
  checked,
  onCheckedChange,
  disabled,
  className,
  "aria-label": ariaLabel,
}: ProToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={cn(
        "toggle relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-0 transition-colors duration-150",
        checked ? "on bg-lime" : "bg-[var(--pro-toggle-off)]",
        disabled && "cursor-not-allowed opacity-50",
        className,
      )}
      onClick={() => onCheckedChange(!checked)}
    >
      <span
        className={cn(
          "toggle-knob absolute top-0.5 left-0.5 size-5 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.3)] transition-transform duration-150",
          checked && "translate-x-5",
        )}
        aria-hidden
      />
    </button>
  );
}

export { ProToggle, type ProToggleProps };
